// src/i18n/users.ts —— 06 admin-console C-03 / C-04 / C-07 文案包（用户管理 / 用户 360 / 用户资金流水；经 PageDef.i18n 挂入 table 域字典，TD-849）。
// 06 给出文案的键逐字取 06（含 Toast 映射表）；06 未给英文或未给键名的标「本计划定稿」（W-7 回写）。
// C-03 人工调账表单键在 funds 包，不在此重复定义
import type { I18nPack } from '../../../shared/src/dc';

export const I18N_USERS: I18nPack = {
  zh: {
    // C-03 用户管理
    emailUnbound: '未绑定邮箱',
    cFeeOwed: '欠费',
    stMerged: '已合并',
    userFormTip: '邮箱与 Telegram 由用户自行绑定，后台修改留痕于操作记录；归属代理变更会影响后续返佣归属。', // [改写 key] SP7 D7-17
    kycReadonlyTip: 'KYC 仅可在用户 360 审核',
    cTermsAt: '条款同意时间',
    errAgentClear: '代理归属用户不可清空上级代理',
    // C-04 用户 360 抽屉
    mergedInto: '已合并至 {uid}',
    cFrozenBal: '冻结',
    toastKycApproved: '已通过 KYC 审核',
    uCommBal: '佣金余额',
    uCommEarned: '累计受益佣金',
    u360: ['概览', '卡片', '资金', '消费', '返佣', '操作记录'], // [改写 key] 第 6 项
    uLog: '操作记录', // [改写 key]
    loadMore: '加载更多',
    kycDocs: 'KYC 材料',
    kycFront: '证件正面',
    kycBack: '证件背面',
    kycSelfie: '手持自拍',
    loadFail: '加载失败',
    kycDocPassport: '护照',
    kycDocId: '身份证',
    // C-07 用户资金流水
    lkCardWithdraw: '卡转出',
    lkCloseRefund: '销卡退回',
    lkFee: '交易手续费',
    lkRevert: '冲正退回',
    stLedgerPending: '待确认',
    stCancel: '已取消',
    // TA 自造键（usr 前缀；06 未给键名，本计划定稿）
    usrErrSplitSave: '资料与状态需分开保存：请先保存资料，再单独修改状态', // C-03 PUT status 与资料互斥（后端 4220 field=status）
    usrErrTgId: 'Telegram ID 须为纯数字', // C-03 Telegram ID 校验
    usrErrEmail: '邮箱格式不正确', // C-03 邮箱格式校验
    usrErrNoteReject: '拒绝时须填写审核备注（≤255 字）', // C-04 KYC 拒绝 note 必填（D27）
    usrRefDoc: '关联单据', // C-07 抽屉字段
    usrKycDocType: '证件类型', // C-04 KYC 字段格
    usrKycName: '姓名',
    usrKycIdNo: '证件号',
    usrKycCountry: '国家',
    usrKycSubmitted: '提交时间',
    usrKycStatus: '审核状态',
    usrKycReviewer: '审核人 · 时间',
    usrKycRejectNote: '驳回原因',
    // 基线 §11.2 流水标题模板（与后端 adminuser.RenderTitle 同文案，CSV 标题列同源）
    usrLtDeposit: 'USDT {network} 充币',
    usrLtDepositFee: '充币手续费',
    usrLtWithdraw: 'USDT {network} 提币',
    usrLtCardOpen: '开卡 {bin}',
    usrLtCardRecharge: '卡充值 •• {last4}',
    usrLtCardWithdraw: '卡转出',
    usrLtCardCloseRefund: '销卡退回',
    usrLtCommissionIn: '返佣转入',
    usrLtManual: '人工调账',
    usrLtFee: '交易手续费',
    usrLtFeeOwedSettle: '欠费抵扣',
    usrLtDepositReorgHold: '充币链重组冻结',
    usrLtRevert: '冲正退回',
    usrLtActRefund: '提币激活费退回',
  },
  en: {
    emailUnbound: 'No email', // 本计划定稿
    cFeeOwed: 'Fee owed',
    stMerged: 'Merged',
    userFormTip: 'Email and Telegram are bound by the user; changes made here are recorded in the operation log. Changing the agent affects future commission attribution.',
    kycReadonlyTip: 'KYC can only be reviewed in User 360', // 本计划定稿
    cTermsAt: 'Terms accepted at',
    errAgentClear: 'Agent-referred users must keep an upline agent', // 本计划定稿
    mergedInto: 'Merged into {uid}', // 本计划定稿
    cFrozenBal: 'Frozen', // 本计划定稿
    toastKycApproved: 'KYC approved',
    uCommBal: 'Commission balance',
    uCommEarned: 'Commission earned',
    u360: ['Overview', 'Cards', 'Funds', 'Spend', 'Commissions', 'Activity'],
    uLog: 'Activity log', // 06 未改英文，沿用原型
    loadMore: 'Load more', // 本计划定稿
    kycDocs: 'KYC documents',
    kycFront: 'ID front', // 本计划定稿
    kycBack: 'ID back', // 本计划定稿
    kycSelfie: 'Selfie with ID', // 本计划定稿
    loadFail: 'Failed to load', // 本计划定稿
    kycDocPassport: 'Passport', // 本计划定稿
    kycDocId: 'ID card', // 本计划定稿
    lkCardWithdraw: 'Card transfer-out',
    lkCloseRefund: 'Close refund',
    lkFee: 'Transaction fee',
    lkRevert: 'Reversal',
    stLedgerPending: 'Pending',
    stCancel: 'Cancelled',
    usrErrSplitSave: 'Save profile and status separately: save the profile first, then change the status',
    usrErrTgId: 'Telegram ID must be numeric',
    usrErrEmail: 'Invalid email address',
    usrErrNoteReject: 'A review note (≤255 chars) is required to reject',
    usrRefDoc: 'Reference',
    usrKycDocType: 'Document type',
    usrKycName: 'Full name',
    usrKycIdNo: 'ID number',
    usrKycCountry: 'Country',
    usrKycSubmitted: 'Submitted at',
    usrKycStatus: 'Review status',
    usrKycReviewer: 'Reviewer · time',
    usrKycRejectNote: 'Rejection reason',
    usrLtDeposit: 'USDT {network} deposit',
    usrLtDepositFee: 'Deposit fee',
    usrLtWithdraw: 'USDT {network} withdrawal',
    usrLtCardOpen: 'Card opened {bin}',
    usrLtCardRecharge: 'Card top-up •• {last4}',
    usrLtCardWithdraw: 'Card transfer-out',
    usrLtCardCloseRefund: 'Close refund',
    usrLtCommissionIn: 'Commission in',
    usrLtManual: 'Manual adjustment',
    usrLtFee: 'Transaction fee',
    usrLtFeeOwedSettle: 'Fee owed settlement',
    usrLtDepositReorgHold: 'Deposit reorg hold',
    usrLtRevert: 'Reversal',
    usrLtActRefund: 'Withdrawal activation fee refund',
  },
};

// TD-805：覆盖原型字典的键（06 [改写 key]）
export const REWRITES_USERS: readonly string[] = ['userFormTip', 'u360', 'uLog'];
